import { win } from '@wix/cashier-common/dist/src/utils/win';

export const perfNow = (): number =>
  win?.performance?.now ? win.performance.now() : Date.now();
